module.exports = __webpack_public_path__ + "static/media/youtube.2038e6b4.svg";